import { SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "checkout",
  useLayout: true,
  children: [{ id: SectionsKey.Checkout, order: 1 }],
};

export default PageStruct;
